/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Ask_Questions_Label_CustomInputs */

const es_components_ask_questions_label_custom = /** @type {(inputs: Components_Ask_Questions_Label_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otro...`)
};

const en_components_ask_questions_label_custom = /** @type {(inputs: Components_Ask_Questions_Label_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other...`)
};

/**
* | output |
* | --- |
* | "Other..." |
*
* @param {Components_Ask_Questions_Label_CustomInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_ask_questions_label_custom = /** @type {((inputs?: Components_Ask_Questions_Label_CustomInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Ask_Questions_Label_CustomInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_ask_questions_label_custom(inputs)
	return en_components_ask_questions_label_custom(inputs)
});
export { components_ask_questions_label_custom as "components.ask_questions.label.custom" }